import { useMemo } from 'react';
import { useBusinessMeta, useExpensesData } from '../../../contexts/dataContextSlices';

export function useExpensesDomain() {
  const meta = useBusinessMeta();
  const expenses = useExpensesData();

  return useMemo(
    () => ({
      ...expenses,
      currentBusinessId: meta.currentBusinessId,
      ready: meta.ready,
      dataLoaded: meta.dataLoaded
    }),
    [meta, expenses]
  );
}
